import React from 'react';
import { Pressable, StyleSheet } from 'react-native';
import Animated, { Extrapolation, interpolate, useAnimatedStyle, } from 'react-native-reanimated';
// Defaults of react-native-modal's own backdrop, which this replaces.
const OPACITY = 0.7;
/**
 * Dims the screen behind `design-system/Modal`, as the sheet's
 * `backdropComponent`.
 *
 * Its opacity follows the sheet's position on the UI thread, so it fades with
 * the slide and with a swipe, and restores on a cancelled swipe.
 */
const ModalBackdrop = ({ animatedIndex, style, visible, opacity = OPACITY, hideOnClose, onPress, }) => {
    const animatedStyle = useAnimatedStyle(() => ({
        opacity: !visible && hideOnClose
            ? 0
            : interpolate(animatedIndex.value, [-1, 0], [0, opacity], Extrapolation.CLAMP),
    }), [visible, opacity, hideOnClose]);
    return (<Animated.View pointerEvents={visible ? 'auto' : 'none'} style={[style, styles.backdrop, animatedStyle]}>
      <Pressable style={StyleSheet.absoluteFill} onPress={onPress} accessible={false}/>
    </Animated.View>);
};
const styles = StyleSheet.create({
    backdrop: {
        ...StyleSheet.absoluteFillObject,
        backgroundColor: 'black',
    },
});
export default ModalBackdrop;
